import React from 'react';

const Tag = ({ item, cl }) => {
  return <div className={cl('item-tag')}>{item}</div>;
};

export default Tag;
